export { menuVariables as menuItemContentVariables } from './menuVariables';
